<template>
  <div class="landing-page-section-editor">
    <v-form class="pb-6">
      <div class="inputs pl-6 pt-6">
        <div class="d-flex align-center">
          <v-text-field
            v-model="theSection.menuTitle"
            solo
            rounded
            hide-details
            label="Menu"
            :disabled="!configurations.menuTitle.visible"
            @input="onChange('menuTitle', $event)"
          ></v-text-field>
          <v-switch
            v-model="configurations.menuTitle.visible"
            inset
            class="ml-6"
            @change="toggle('menuTitle', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center">
          <v-text-field
            solo
            rounded
            hide-details
            label="Imagem"
            disabled
            @input="onChange('logoSrc', $event)"
          ></v-text-field>
          <v-switch
            v-if="configurations.logoSrc"
            v-model="configurations.logoSrc.visible"
            inset
            class="ml-6"
            @change="toggle('logoSrc', $event)"
          ></v-switch>
          <sigfoco-upload-file
            :size="12"
            :maxSize="0.1"
            :formats="'.PNG, .JPG, .JPEG'"
            v-model="theSection.logoSrc"
            onlyIcon
            ref="uploadFileComponentLogo"
          ></sigfoco-upload-file>
        </div>

        <div class="d-flex align-center">
          <v-select
            v-model="theSection.leftImage"
            :items="configurations.leftImage.positions"
            item-text="title"
            item-value="value"
            solo
            rounded
            hide-details
            label="Posição da Imagem"
          ></v-select>
          <v-switch :input-value="true" inset class="ml-6" disabled></v-switch>
        </div>

        <div class="d-flex align-center">
          <v-text-field
            v-model="theSection.title"
            solo
            rounded
            hide-details
            label="Título"
            maxlength="100"
            :disabled="!configurations.title.visible"
            @input="onChange('title', $event)"
          ></v-text-field>
          <v-switch
            v-model="configurations.title.visible"
            inset
            class="ml-6"
            @change="toggle('title', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center mt-2">
          <v-textarea
            v-model="theSection.content"
            solo
            hide-details
            label="Informação"
            maxlength="5000"
            :disabled="!configurations.content.visible"
            @input="onChange('content', $event)"
          ></v-textarea>
          <v-switch
            v-model="configurations.content.visible"
            inset
            class="ml-6"
            @change="toggle('content', $event)"
          ></v-switch>
        </div>
      </div>

      <div class="d-flex flex-row-reverse pt-6">
        <v-menu
          v-model="menuSave"
          offset-y
          transition="slide-y-transition"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="success"
              rounded
              text
              class="text-capitalize mr-4"
              >Salvar</v-btn
            >
          </template>
          <v-card max-width="300" class="not-margin">
            <v-card-title class="text-h5"> Deseja confirmar essa operação? </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                text
                small
                class="py-4"
                @click="menuSave = false"
              >
                Desistir
              </v-btn>
              <v-btn
                color="error darken-1"
                rounded
                text
                small
                class="py-4"
                @click="save"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
        <v-menu
          v-model="menuDelete"
          offset-y
          transition="slide-y-transition"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="error"
              rounded
              text
              class="text-capitalize mr-4"
              >Remover</v-btn
            >
          </template>
          <v-card max-width="300" class="not-margin">
            <v-card-title class="text-h5"> Tem Certeza? </v-card-title>

            <v-card-text>
              Se você continuar, esta seção será removida da página inicial do
              sistema.
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                text
                small
                class="py-4"
                @click="menuDelete = false"
              >
                Desistir
              </v-btn>
              <v-btn
                color="error darken-1"
                rounded
                text
                small
                class="py-4"
                @click="remove"
              >
                Remover
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </div>
    </v-form>
  </div>
</template>

<script>
import { get as _get, set as _set } from "lodash";

import { Section } from "components/landing-page/LandingPageSection";

export default {
  name: "LandingPageEditorSectionEditor",
  props: {
    section: {
      type: Section,
      required: true,
    },
  },
  data: () => ({
    menuDelete: false,
    menuSave: false,
    theSection: new Section(),
    configurations: {
      menuTitle: {
        visible: true,
        value: undefined,
      },
      logoSrc: {
        visible: true,
        value: undefined,
      },
      title: {
        visible: true,
        value: undefined,
      },
      content: {
        visible: true,
        value: undefined,
      },
      leftImage: {
        visible: true,
        value: undefined,
        positions: Object.freeze([
          { title: "Imagem à Esquerda", value: true },
          { title: "Imagem à Direita", value: false },
        ]),
      },
    },
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.theSection = this.section;
      if (this.$refs.uploadFileComponentLogo){
        this.$refs.uploadFileComponentLogo.setAnexo(this.theSection.logoSrc ?? null);
      }
      this.confitureItem("menuTitle");
      this.confitureItem("logoSrc");
      this.confitureItem("leftImage");
      this.confitureItem("title");
      this.confitureItem("content");
    },
    confitureItem(modelPath) {
      const model = _get(this.theSection, modelPath);
      const configuration = _get(this.configurations, modelPath);

      configuration.visible = !!model;
      configuration.value = model;
    },
    remove() {
      this.$emit("on-remove", this.section);
    },
    save() {
      this.$emit("on-save", this.section);
      this.menuSave = false;
    },
    toggle(modelPath, visible) {
      const configuration = _get(this.configurations, modelPath);
      configuration.visible = visible;

      if (visible) {
        _set(this.theSection, modelPath, configuration.value);
      } else {
        _set(this.theSection, modelPath, undefined);
      }
    },
    onChange(convigurationPath, value) {
      _set(this.configurations, convigurationPath + ".value", value);
    },
  },
};
</script>
